import { useEffect, memo } from "react";
import { useAppSelector } from "app/hooks";
import Box from "@mui/material/Box";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useField, Field } from "formik";
import ErrorMessage from "ui/atoms/ErrorMessage";

const FieldCheckboxGroup = memo(({ name, label, subSectionId, dataSource, checkboxStyle, isVisible = true }: any) => {
  const [field, meta, helpers] = useField(name);
  const error = !!meta.error && meta.touched;

  const { answers } = useAppSelector((state) => state.survey) ?? [];
  const id = name.split(".")[2];
  const answer =
    answers
      .filter((answer) => answer.questionID === id && answer.subSectionId === subSectionId)
      .map((answer) => answer.value) || [];

  useEffect(() => {
    if (answer) helpers.setValue(answer);
  }, []);

  if (!dataSource) return <></>;
  return isVisible ? (
    <Box sx={{ display: "flex" }}>
      <FormControl sx={{ mt: 2 }} name={name} variant='standard' component='fieldset' error={error}>
        <FormLabel component='legend'>{label}</FormLabel>
        <FormGroup row>
          {dataSource?.map((item: any) => {
            return (
              <Field
                type='checkbox'
                name={name}
                value={item?.value}
                as={FormControlLabel}
                sx={checkboxStyle}
                control={<Checkbox checked={field?.value?.includes(item.value)} />}
                label={item.descripcion}
              />
            );
          })}
        </FormGroup>
        <ErrorMessage>{meta?.touched && meta?.error}</ErrorMessage>
      </FormControl>
    </Box>
  ) : null;
});

export default FieldCheckboxGroup;
